import script from "./LilaMessageTyper.vue?vue&type=script&setup=true&lang=js"
export * from "./LilaMessageTyper.vue?vue&type=script&setup=true&lang=js"

import "./LilaMessageTyper.vue?vue&type=style&index=0&id=70f1f0c1&lang=css"

const __exports__ = script;

export default __exports__